import { isEqual } from 'lodash'
import * as React from 'react'
import * as styles from './index.module.css'

interface ICache {
  get(cacheKey: string): number | null
  set(cacheKey: string, variantId: number): any
}

interface IProps {
  id: string
  defaultVariantId: number
  location: any
  forcedVariantId?: number | null
  cache?: ICache
  children: Array<React.ReactElement<any>>
  preloader?: React.ReactElement<any>
  onExperimentView?(expermentId: string, variantId: number): void
  fetchVariantId?(experimentId: string): Promise<number>
}

interface IState {
  loading: boolean
  variantId: number | null
}

class Experiment extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      loading: true,
      variantId: null
    }
  }

  public componentDidMount() {
    if (this.props.forcedVariantId || this.props.forcedVariantId === 0) {
      this.forceVariantId(this.props.forcedVariantId)
    }

    this.getVariantId().then((variantId: number) => {
      const { id, onExperimentView } = this.props
      if (onExperimentView && (variantId === 0 || variantId)) {
        onExperimentView(id, variantId)
      }
      this.setState({ loading: false, variantId })
    })
  }

  public componentWillReceiveProps(nextProps: IProps) {
    const { variantId } = this.state
    const { id, onExperimentView } = this.props

    const navigated = !isEqual(nextProps.location, this.props.location)
    if (navigated && onExperimentView && (variantId === 0 || variantId)) {
      onExperimentView(id, variantId)
    }
  }

  public render() {
    const { loading, variantId } = this.state
    const { preloader, defaultVariantId } = this.props

    const showPreloader = loading && preloader
    return (
      <div className={styles.experimentContainer}>
        {showPreloader && this.seoFriendlyPreloader()}
        {this.findVariantById(variantId || defaultVariantId)}
      </div>
    )
  }

  private seoFriendlyPreloader() {
    return <div className={styles.preloaderOverlay}>{this.props.preloader}</div>
  }

  private nullCache() {
    return {
      get: () => null,
      set: () => null
    }
  }

  private cache() {
    if (this.props.cache == null) {
      return this.nullCache()
    } else {
      return this.props.cache
    }
  }

  private fetchVariantId() {
    return this.props.fetchVariantId && this.props.fetchVariantId(this.props.id)
  }

  private experimentKey() {
    return `experiment_${this.props.id}`
  }

  private getCachedVariantId() {
    return this.cache().get(this.experimentKey())
  }

  private setCachedVariantId(variantId: number) {
    return this.cache().set(this.experimentKey(), variantId)
  }

  private forceVariantId(forcedVariantId: number) {
    const availableVariants = this.props.children.map(
      child => child.props.variantId
    )

    if (availableVariants.includes(forcedVariantId)) {
      this.setCachedVariantId(forcedVariantId)
    }
  }

  private chooseRandomVariantId() {
    const randomIndex = Math.floor(Math.random() * this.props.children.length)
    const choosenVariantComponent = this.props.children[randomIndex]
    return Promise.resolve(choosenVariantComponent.props.variantId as number)
  }

  private getVariantId(): Promise<number> {
    const cachedVariantId = this.getCachedVariantId()
    if (cachedVariantId || cachedVariantId === 0) {
      return Promise.resolve(cachedVariantId)
    } else {
      return (this.fetchVariantId() || this.chooseRandomVariantId())
        .then((variantId: number) => {
          this.setCachedVariantId(variantId)
          return variantId
        })
        .catch(err => {
          const originalVariant = this.props.children[0]
          return originalVariant.props.variantId as number
        })
    }
  }

  private findVariantById(variantId: number) {
    return this.props.children.find(v => v.props.variantId === variantId)
  }
}

export default Experiment



// WEBPACK FOOTER //
// ./client/components/experiment/index.tsx